export const APP_BASENAME = "/business";

export const ACCESS_TOKEN_KEY = "__access_token__";
export const REFRESH_TOKEN_KEY = "__refresh_token__";

export const MIN_FIELD_WIDTH = "200px";

export const SCREEN_BREAKPOINTS = {
  mobile: 320,
  mobileLarge: 576,
  tablet: 768,
  desktop: 1024,
  desktopLarge: 1280,
  desktopXLarge: 1440,
  desktopXXLarge: 1680,
  desktopXXXLarge: 1920,
};

export const TOP_SPACE = "40px";
export const LINE_SPACE = "20px";

export const QUERY_RETRY = 3;

export const LANGUAGES_MAP: Record<string, string> = {
  he: "iw",
};
